import React from 'react';

const BlankSpace = () => {
  return <div className="py-2 my-4"></div>;
};

export default BlankSpace;
